import { render, staticRenderFns } from "./ProjectPreviewContent.vue?vue&type=template&id=05baff57&scoped=true"
import script from "./ProjectPreviewContent.vue?vue&type=script&lang=js"
export * from "./ProjectPreviewContent.vue?vue&type=script&lang=js"
import style0 from "./ProjectPreviewContent.vue?vue&type=style&index=0&id=05baff57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05baff57",
  null
  
)

export default component.exports